import React, { Component } from "react";
import HttpServices from "../../utils/Http.services";
import { checkTranslation, imageAddress, translate } from "../../utils/useful";


class SearchGroupsFixedView extends Component {

    state = {
        data: [],
        group: {}
    }

    componentDidMount() {
        this.initData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.groupsInitData != this.props.groupsInitData) {
            this.initData()
        }
    }

    initData = () => {
        this.fetchData()
        this.setState({ group: {} }, () => {
            if (Array.isArray(this.props.groupsInitData)) {
                let group = this.state.group
                this.props.groupsInitData.forEach(element => {
                    group[element._id] = element//{ _id: element._id, removed: false, init: true }
                    group[element._id].removed = false
                    group[element._id].init = true
                });
            }
        })
    }

    fetchData = () => {
        this.setState({ isLoadingData: true })
        let body = { applet: '{{appletId}}', appletHub: "{{appletHub}}", hub: "{{targetId}}", targetId: "{{targetId}}" }
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    if (typeof body[key] == 'object') {
                        body[key] = body[key]._id
                    }
                }
            }
        }
        HttpServices.request('getConnectionGroups', body, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                return
            }
            this.setState({ rawData: fetchResult.info, data: fetchResult.info })
        })
    }

    onDone = (prop) => {
        let group = this.state.group
        group = { _id: prop._id, name: prop.name }
        let final = []
        final.push(group)
        this.setState({ group }, () => {
            setTimeout(() => {
                this.props.onDone('groups', final, 'group', () => {
                }, 50);
            })
        })
    }

    search(value) {
        let data = this.state.rawData
        data = data.filter(e => e.name?.toLowerCase().includes(value.toLowerCase()))
        this.setState({ data })
    }

    render() {
        return (
            <div className='bg-white br-10 p-1 shadow-3 sc-gray2' style={{}}>
                <div className="d-flex h-100 flex-column w-100 scroll-no-scrollbar" style={{ backgroundColor: '#fff', borderRadius: 8, position: 'relative', }}>
                    <div className="w-100 text-start">
                        {this.state.data.map((prop, index) => {
                            return (
                                <div key={prop._id} onClick={() => this.changeSelect(prop)} className="flexcb pt-2 pb-2 backHover pld-3 prd-3  cursor-pointer transition-all" style={{}}>
                                    <p className="text-small text-semibold  ">{checkTranslation(prop.name)}</p>
                                </div>
                            )
                        })}
                        {this.state.data?.length === 0 && (
                            <div className="text-center my-3">
                                <p className="text-center text-small">{translate('found-nothing')}</p>
                                {/* <p className="text-center text-smaller">{translate('ca.Change your search options')}</p> */}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );

    }
}


export default SearchGroupsFixedView;
